import React, { useEffect, useRef } from 'react';
import { IoCheckmarkSharp } from "react-icons/io5";

const PaymentSuccess = () => {
  const tickIconRef = useRef(null);
  const contentRef = useRef(null);
  const borderRef = useRef(null);

  useEffect(() => {
    // Animation sequence
    const timer1 = setTimeout(() => {
      if (tickIconRef.current) {
        tickIconRef.current.style.opacity = '1';
        tickIconRef.current.style.transform = 'scale(1)';
      }
    }, 300);

    const timer2 = setTimeout(() => {
      if (tickIconRef.current) {
        tickIconRef.current.style.transform = 'scale(1.1) translateY(-10px)';
      }
    }, 800);

    const timer3 = setTimeout(() => {
      if (tickIconRef.current) {
        tickIconRef.current.style.transform = 'scale(1) translateY(-10px)';
      }
      if (contentRef.current) {
        contentRef.current.style.opacity = '1';
        contentRef.current.style.transform = 'translateY(0)';
      }
      if (borderRef.current) {
        borderRef.current.style.width = '100%';
      }
    }, 1200);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  return (
    <div id='PaymentSuccess'>
      <div className='container'>
        <div className='PaymentSuccessMain'>
          <div className='PaymentSuccessBox'>
            <div 
              className='TickIcon' 
              ref={tickIconRef}
            >
              <IoCheckmarkSharp />
            </div>
            
            <div className='border-line' ref={borderRef}></div>
            
            <div className='PaymentSuccessHeadBox' ref={contentRef}>
              <div className='PaymentSuccessTitle'>
                <p>Thank you for your Purchase</p>       
              </div>
              <div className='PaymentSuccessDesc'>
                <p>Your payment was successful! We've received your order and will process it shortly.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentSuccess;